type RoutesType = typeof ROUTES;
type RouteKeys = keyof RoutesType;
export type RoutePaths = RoutesType[RouteKeys];

export const ROUTES = {
  HOME: '/',
  LAYOUTVIEW:'/dashboard/atulit-admin',
  USERS_ADMIN_DETAIL: `/users/admin/:id/detail`,
  USERS_ADMIN_EDIT: `/users/admin/:id/edit`,
  DASHBOARD: '/dashboard',
  REPORT:'/report',
  ACCOUNT_SETTINGS: '/account-settings',
  USERS_APP: '/admins',
  USERS_APP_EDIT: `/admins/:id/edit`,
  LOGIN: '/login',
  USERS: '/users',
  WELCOME:'/welcome',
  MASTER:'/master',
  MATERIAL:'/master/material',
  UNLOADING_LOG:'/unloading/log',
  LOADING_LOG:'/loading/log',
  SUPPLIER:'/master/supplier',
  STATION:'/master/station',
  WEIGHBRIDEGE:"/master/Weighbridge",
  RoleManagement: '/role-management',
  MATERIAL_DETAIL_LOG:'/material-datail', 
  LOG:"/vechile/log",
  TAT:'/report/tat',
  TOLRANCE:'/report/tolrance',
  VECHILE:'/report/vechile',
  SALES:'/report/sales',
  PURACHASE:'/report/purachase',
  LOG_LOADING:'/vechile/loading',
  LOG_UPLOADING:'/vechile/Uploading',
  LOG_ADMIN_DETAIL:'/log/:id/detail', 
  Setting:'/Setting',
  NOTIFICATION:'/notifications',
  NOT_FOUND: '*',
  // REGISTRATION_FORM: '/event-registraion-form',
} as const;


export const SideBarMenus = {
  DASHBOARD: 'dashboard',
  USERMANAGEMENT: 'user-management',
  MASTER:'master',
  ADMIN:'admins' ,
  REPORTS:'reports',
  Logs:'logs',
  ENTRYLOGS:'entry-logs',
  LOADINGLOGS:'loading-logs',
  UNLOADINGLOGS:'unloading-logs',
  WEIGHBRIDGE:'weighbridge',
  SUPPLIER:'supplier',
  STATIONS:'station',
  MATERIAL:'material',
  MATERIALDETAIL:'material-detail',
  SALES:'sales',
  VEHICLEREPORT:'vehicle-entry',
  TOLERANCEREPORT:'tolerance',
  TATREPORT:'tat',
  SETTINGS:'setting',
  WBPRIORITY:'weighbridge-priority', 
  PURCHASE:'purchase',
  NOTIFICATIONS:'notifications'
} as const;